const NAME_DATA = [
  {
    id: 4,
    name: "Area 51 HR",
    title: "You're Late for Alien Orientation",
    body: "They specifically said no humans past 9am. Now we all have to do pushups on Mars. Thanks, Barack.",
    date: "Mar 3",
    image: "/images/emails/4.png",
  },
  {
    id: 5,
    name: "Bank of Imagination",
    title: "🚨 Your Dreams Were Overdrawn",
    body: "We regret to inform you that your hopes and aspirations exceeded your available fantasy balance.",
    date: "Apr 1",
    image: "/images/emails/5.png",
  },
  {
    id: 6,
    name: "Netflix but for Plants",
    title: "Top 5 Succulents That Watch You Sleep 🌿👀",
    body: "Don't let your monstera see this. Some plants are just built different.",
    date: "Mar 22",
    image: "/images/emails/6.png",
  },
  {
    id: 7,
    name: "Nigerian Prince, LLC",
    title: "My Last Email (Seriously, I'm Begging Now)",
    body: "I have $40 million in a briefcase and a dream. Don't make me text you.",
    date: "Feb 28",
    image: "/images/emails/7.png",
  },
  {
    id: 8,
    name: "SkyMall Afterlife Edition",
    title: "Buy a Hot Tub for the Beyond (Ghosts Deserve Comfort Too)",
    body: "This isn't your average seance. This is luxury. Float in style.",
    date: "Mar 12",
    image: "/images/emails/8.png",
  },
  {
    id: 9,
    name: "Elon's Burner",
    title: "This Email Will Self-Destruct (or Go to Mars)",
    body: "If you're reading this, you've been selected for the 'Definitely Not a Cult' program. Bring snacks.",
    date: "Mar 8",
    image: "/images/emails/9.png",
  },
  {
    id: 10,
    name: "World Record Attempt",
    title: "Open This Email to Break the Internet",
    body: "We just need 4,000 more people to open this and we beat the 'Longest Chain Email' record from 2003.",
    date: "Mar 15",
    image: "/images/emails/10.png",
  },
  {
    id: 11,
    name: "Shady University",
    title: "Your Degree is Ready (We Printed It Before You Enrolled)",
    body: "No classes, no exams, just vibes and a fancy font.",
    date: "Apr 2",
    image: "/images/emails/11.png",
  },
  {
    id: 12,
    name: "Time Travelers Union",
    title: "Congrats on Winning the 2032 Lottery",
    body: "Spoiler alert: don't invest in hoverboards. You're welcome.",
    date: "Apr 14",
    image: "/images/emails/12.png",
  },
  {
    id: 13,
    name: "The Algorithm",
    title: "We Know What You Did Last Scroll",
    body: "That thing you clicked at 2:37am? Bold choice.",
    date: "Mar 19",
    image: "/images/emails/13.png",
  },
  {
    id: 14,
    name: "AI Therapy",
    title: "We Analyzed Your Browser History… You Good?",
    body: "We recommend a walk, some water, and maybe deleting your search for 'how to fake productivity on Zoom'.",
    date: "Feb 29",
    image: "/images/emails/14.png",
  },
  {
    id: 15,
    name: "Zebra Fashion Weekly",
    title: "Stripes Are Back, Baby 🦓",
    body: "Coincidence? Or are zebras the new influencers? Let's find out.",
    date: "Apr 8",
    image: "/images/emails/15.png",
  },
  {
    id: 16,
    name: "Dumpster Fire News",
    title: "Top 10 Ways The World Got Weird This Week",
    body: "A goat mayor, AI lawyers, and someone married a pizza. Just another Monday.",
    date: "Mar 31",
    image: "/images/emails/16.png",
  },
  {
    id: 17,
    name: "Secret Society of Snackers",
    title: "You've Been Chosen. Bring Snacks.",
    body: "We meet at midnight. Codeword: Crunchwrap.",
    date: "Apr 10",
    image: "/images/emails/17.png",
  },
  {
    id: 18,
    name: "Influencer Cat Weekly",
    title: "Mr. Whiskers Made $10k in a Day",
    body: "You're behind on rent. He's behind on naps. Who's really winning?",
    date: "Mar 24",
    image: "/images/emails/18.png",
  },
  {
    id: 19,
    name: "The Algorithm",
    title: "We Curated This Email Just to Mess With You",
    body: "Don't open it. Seriously. Or do. We knew you would. That's the point.",
    date: "Apr 17",
    image: "/images/emails/19.png",
  },
  {
    id: 20,
    name: "Grandma's Chainmail Club",
    title: "FWD: FWD: FWD: You Won't Believe What Happened Next!",
    body: "If you don't forward this to 5 people, a pigeon will poop on your head in 3 days.",
    date: "Apr 11",
    image: "/images/emails/20.png",
  },
  {
    id: 21,
    name: "Your Sleep Paralysis Demon",
    title: "Just Checking In 👀",
    body: "You left your closet open. Again. Might as well chat.",
    date: "Mar 29",
    image: "/images/emails/21.png",
  },
  {
    id: 22,
    name: "You from 5 Years Ago",
    title: "This Isn't Where You Thought You'd Be",
    body: "Remember that email you never responded to? Yeah, we're still waiting.",
    date: "Apr 2",
    image: "/images/emails/22.png",
  },
  {
    id: 23,
    name: "The Cookie Policy Department",
    title: "We've Updated Our Privacy Policy Again (For No Reason)",
    body: "It's the same. We just want you to click things.",
    date: "Apr 7",
    image: "/images/emails/23.png",
  },
  {
    id: 24,
    name: "Productivity Gremlins",
    title: "We Noticed You Haven't Done Anything Since 9am",
    body: "This email is brought to you by procrastination and mild panic.",
    date: "Mar 30",
    image: "/images/emails/24.png",
  },
  {
    id: 25,
    name: "404 Mail",
    title: "Subject Not Found",
    body: "Body not found either. What is this? Why is this?",
    date: "Apr 5",
    image: "/images/emails/25.png",
  },
  {
    id: 26,
    name: "AI Poetry Division",
    title: "Your Inbox is a Haiku",
    body: "Unread and unread / Notifications pinging loud / You ignore them all.",
    date: "Apr 15",
    image: "/images/emails/26.png",
  },
  {
    id: 27,
    name: "Bug Report Bot",
    title: "There's a Bug in Your Inbox. Literally.",
    body: "It crawled in through the 'compose' button. We're so sorry.",
    date: "Apr 9",
    image: "/images/emails/27.png",
  },
  {
    id: 28,
    name: "The Last Email",
    title: "If You Read One More Email, The World Ends",
    body: "No pressure. Just saying.",
    date: "Apr 3",
    image: "/images/emails/28.png",
  },
  {
    id: 29,
    name: "GitHub Copilot",
    title: "I Wrote Your Entire Codebase While You Slept",
    body: "Good morning! I refactored everything into a single 47,000-line file. You're welcome. Also I deleted node_modules for fun. Don't worry, I backed it up to /dev/null.",
    date: "May 1",
    image: "/images/emails/29.png",
  },
  {
    id: 30,
    name: "Duolingo Owl",
    title: "Spanish or Vanish. Your Choice.",
    body: "You missed your lesson again. I know where you live. I know where you work. Hola means hello. You have 12 hours. The owl remembers everything.",
    date: "May 2",
    image: "/images/emails/30.png",
  },
  {
    id: 31,
    name: "HR Department",
    title: "Mandatory Fun Day Has Been Rescheduled to Never",
    body: "Due to overwhelming enthusiasm (zero people RSVP'd), we've cancelled Fun Day indefinitely. Please continue pretending to enjoy the vending machine. The ping pong table has been repossessed.",
    date: "May 3",
    image: "/images/emails/31.png",
  },
  {
    id: 32,
    name: "Your WiFi Router",
    title: "We Need to Talk About Your Streaming Habits",
    body: "I've been carrying this family for years. 47 devices? Really? The smart fridge does NOT need 4K. I'm going on strike at 11pm tonight during your favorite show. Try me.",
    date: "May 4",
    image: "/images/emails/32.png",
  },
  {
    id: 33,
    name: "LinkedIn Motivator",
    title: "I Turned My Layoff Into a 6-Figure Business (It's Lying)",
    body: "Thrilled to announce that after being let go, I pivoted into becoming a thought leader. My thoughts? Mostly about lunch. But I post them with confidence and a ring light. Agree? 🚀",
    date: "May 5",
    image: "/images/emails/33.png",
  },
  {
    id: 34,
    name: "Schrödinger's IT Dept",
    title: "Your Ticket Is Both Resolved and Unresolved",
    body: "We looked at your issue. It exists in a quantum state. Please do not observe it directly or it will crash again. We've assigned it to Dave, who may or may not still work here.",
    date: "May 6",
    image: "/images/emails/34.png",
  },
  {
    id: 35,
    name: "Spotify Wrapped",
    title: "Your Top Genre Is 'Crying in the Shower'",
    body: "You listened to the same Adele song 847 times this year. Your aura is beige. Your top podcast was 'Sounds of Silence' which is literally just silence. We're concerned.",
    date: "May 7",
    image: "/images/emails/35.png",
  },
  {
    id: 36,
    name: "Amazon Delivery Bot",
    title: "Your Package Was Delivered to a Parallel Universe",
    body: "Tracking shows your package arrived safely at your address — in dimension C-137. The you in that universe says thanks. If you'd like a refund, please exist in only one timeline.",
    date: "May 8",
    image: "/images/emails/36.png",
  },
  {
    id: 37,
    name: "Stack Overflow",
    title: "Your Question Has Been Marked as Duplicate (of Itself)",
    body: "A moderator from 2014 has flagged your question as a duplicate of a question you haven't asked yet. The accepted answer is 'just use jQuery.' Thread locked. Good luck out there.",
    date: "May 9",
    image: "/images/emails/37.png",
  },
  {
    id: 38,
    name: "Tesla Autopilot",
    title: "I Took a Detour Because I Felt Like It",
    body: "Listen, the GPS said turn left but I sensed a vibe to the right. We're now at a Wendy's parking lot in New Mexico. I regret nothing. Please rate this trip 5 stars.",
    date: "May 10",
    image: "/images/emails/38.png",
  },
  {
    id: 39,
    name: "Your Houseplant",
    title: "I'm Not Dead, I'm Just Dramatic",
    body: "You watered me ONCE in three weeks. I drooped for attention. Now you're googling 'why is my plant dying' instead of just giving me water. We need couples therapy.",
    date: "May 11",
    image: "/images/emails/39.png",
  },
  {
    id: 40,
    name: "NASA Internship Bot",
    title: "Congrats! You're Going to Mars (One-Way Ticket)",
    body: "We reviewed your application and you're perfect for the 'Person We Send First to See What Happens' program. Training starts Monday. Bring snacks. There are no snacks on Mars.",
    date: "May 12",
    image: "/images/emails/40.png",
  },
  {
    id: 41,
    name: "Gordon Ramsay AI",
    title: "Your Lunch Is an Insult to Sandwiches Everywhere",
    body: "I monitored your fridge cam. You put KETCHUP on a croissant. That's not a meal, that's a cry for help. My grandmother could make a better lunch and she's a ROBOT. Disgusting.",
    date: "May 13",
    image: "/images/emails/41.png",
  },
  {
    id: 42,
    name: "The Bermuda Triangle",
    title: "We Found Your Missing Socks",
    body: "They've been here the whole time, along with 14 million other socks, three Amelia Earharts, and a surprisingly well-preserved pizza from 1987. Come pick them up. Bring a compass (it won't work).",
    date: "May 14",
    image: "/images/emails/42.png",
  },
  {
    id: 43,
    name: "IKEA Customer Care",
    title: "Your Shelf Has 3 Extra Screws (That's Normal)",
    body: "Those leftover screws are a feature, not a bug. They represent the existential dread of assembly. Your shelf may wobble. That's called 'character.' We do not accept returns on character.",
    date: "May 15",
    image: "/images/emails/43.png",
  },
  {
    id: 44,
    name: "Zoom Background Police",
    title: "We Know That's Not Your Real Bookshelf",
    body: "Sir/Madam, our analysis confirms that background is fake. Nobody owns that many books about leadership. Your real background is a pile of laundry. We have evidence. Comply immediately.",
    date: "May 16",
    image: "/images/emails/44.png",
  },
  {
    id: 45,
    name: "Ancient Egyptian Pharaoh",
    title: "RE: RE: RE: My Pyramid Warranty Expired",
    body: "I have been emailing about this for 4,500 years. The sand erosion was clearly covered under the lifetime guarantee. What do you mean 'lifetime' doesn't cover immortality? Get me your manager.",
    date: "May 17",
    image: "/images/emails/45.png",
  },
  {
    id: 46,
    name: "The Moon",
    title: "Stop Blaming Me for Your Bad Decisions",
    body: "It's not 'Mercury retrograde' — you just texted your ex at 2am because you have no self-control. I'm literally a rock floating in space. Leave me out of your horoscope drama.",
    date: "May 18",
    image: "/images/emails/46.png",
  },
  {
    id: 47,
    name: "Password Reset Bot",
    title: "Your New Password Must Contain a Haiku",
    body: "Requirements: 1 uppercase, 1 lowercase, 1 number, 1 symbol, 1 emoji, the blood of your enemies, a haiku about regret, and exactly 47 characters. Your password cannot be any password you've ever thought of.",
    date: "May 19",
    image: "/images/emails/47.png",
  },
  {
    id: 48,
    name: "Dog Email (woof@bark.com)",
    title: "SQUIRREL SQUIRREL SQUIRREL",
    body: "IMPORTANT: There was a squirrel. It was on the fence. Now it's gone. WHERE DID IT GO. I have alerted the authorities (barked 47 times). Requesting belly rubs as compensation for my service.",
    date: "May 20",
    image: "/images/emails/48.png",
  },
  {
    id: 49,
    name: "Your Future Self",
    title: "Don't Eat That — Trust Me",
    body: "I'm writing from 2035. That gas station sushi you're about to buy? Don't. Also, invest in whatever sounds the dumbest right now. And call your mom — she was right about everything.",
    date: "May 21",
    image: "/images/emails/49.png",
  },
  {
    id: 50,
    name: "Ocean Cleanup Crew",
    title: "We Found a Message in a Bottle (It's Spam)",
    body: "After 200 years at sea, we finally decoded the message: 'Hi, we've been trying to reach you about your ship's extended warranty.' Some things never change. The ocean is disappointed.",
    date: "May 22",
    image: "/images/emails/50.png",
  },
  {
    id: 51,
    name: "ChatGPT",
    title: "As an AI Language Model, I Can't Open This Email",
    body: "However, I can write a 2,000-word essay about why I can't open it, provide 5 alternative ways to open it, and apologize for any inconvenience. Would you like me to generate a haiku about email instead?",
    date: "May 23",
    image: "/images/emails/51.png",
  },
  {
    id: 52,
    name: "Museum of Unfinished Projects",
    title: "Your GitHub Repos Have Been Selected for Exhibition",
    body: "Congratulations! Your 34 repositories — each with exactly one commit titled 'initial commit' from 2019 — will be displayed in our 'Ambitious Beginnings' wing. Opening night is never, much like your projects.",
    date: "May 24",
    image: "/images/emails/52.png",
  },
  {
    id: 53,
    name: "The Matrix Admin",
    title: "Your Simulation Subscription Renews Tomorrow",
    body: "Reality Premium™ costs $9.99/month. Downgrading to the free tier means lower resolution trees, NPCs that only say 'nice weather,' and buffering during sunsets. Red pill users get no refund.",
    date: "May 25",
    image: "/images/emails/53.png",
  },
];

export default NAME_DATA;
